export default (state = [], action) => {
  switch (action.type) {
    case 'NEWSFEED/ADD_POSTS':
      return [...state, ...action.data];
    case 'NEWSFEED/CLEAR_POSTS':
      return [];
    default:
      return state;
  }
};
